export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
      },
      {
        _children: [
          {
            _name: 'CSidebarNavItem',
            name: 'Users',
            to: '/users-list',
            icon: 'cil-user',
          },
        ]
      },
      {
        _children: [
          {
            _name: 'CSidebarNavItem',
            name: 'Adverts',
            // route: '/base',
            icon: 'cil-people',
            name: 'Adverts',
            to: '/adverts-list'
          }
        ]
      },
      {
        _children: [
          {
            _name: 'CSidebarNavItem',
            name: 'Adverts',
            // route: '/base',
            icon: 'cil-dollar',
            name: 'Credits',
            to: '/credits-list'
          }
        ]
      },
      {
        _children: [
          {
            _name: 'CSidebarNavItem',
            name: 'Credit Settings',
            to: '/credit-settings',
            icon: 'cil-cog',
          },
        ]
      },
      {
        _children: [
          {
            _name: 'CSidebarNavItem',
            name: 'Free Credit Settings',
            to: '/free-credit-settings',
            icon: 'cil-Options',
          },
        ]
      },
      {
        _children: [
          {
            _name: 'CSidebarNavItem',
            name: 'Reason',
            to: '/reason-list',
            icon: 'cil-list',
          },
        ]
      },
      {
        _children: [
          {
            _name: 'CSidebarNavItem',
            name: 'Report',
            to: '/report-list',
            icon: 'cil-file',
          },
        ]
      }
    ]
  }
]
